import React, { useEffect, useState } from "react";
import { storage } from "../../../firebase";
import { getDownloadURL, ref } from "firebase/storage";
import { AvatarButton } from "../../../design/avatar";
import { Dialog, DialogActions, DialogBody } from "../../../design/dialog";
import { Button } from "../../../design/button";

interface AsyncImageProps {
  path: string;
  alt?: string;
}

const ImageThumbnail: React.FC<AsyncImageProps> = ({ path, alt = "Image" }) => {
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const fileRef = ref(storage, path);
        const downloadUrl = await getDownloadURL(fileRef);
        setImageUrl(downloadUrl);
      } catch (err) {
        console.error("Error fetching image:", err);
      }
    };

    fetchImage();
  }, [path]);

  if (!imageUrl) {
    return null;
  }

  return (
    <>
      <AvatarButton
        square
        className="size-8"
        src={imageUrl}
        alt={alt}
        onClick={() => setIsOpen(true)}
      />
      <Dialog open={isOpen} onClose={setIsOpen}>
        <DialogBody>
          <img src={imageUrl} alt={alt} />
        </DialogBody>
        <DialogActions>
          <Button onClick={() => setIsOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ImageThumbnail;
